/**
 * Date utility functions for formatting dates in Brasília timezone
 */

/**
 * Format date in Brasília timezone
 * @param {Date|string} date - Date to format
 * @returns {string} Formatted date string
 */
export function formatBrasiliaDate(date) {
  if (!date) return 'N/A';
  
  return new Date(date).toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

/**
 * Format time in Brasília timezone
 * @param {Date|string} date - Date to format
 * @returns {string} Formatted time string
 */
export function formatBrasiliaTime(date) {
  if (!date) return 'N/A';
  
  return new Date(date).toLocaleTimeString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}